export type EmailData = {
    domain: string
    assetDomain: string
}

export const PLACEHOLDER_NAME = 'there'
